module.exports = "<section class='nflow-debug'>\n  <div class=\"content\">\n      \n    <section class=\"nodes\">\n      <figure class='nflow-tree'></figure>\n      <figure class='nflow-timeline'></figure>\n    </section>\n    <aside class=\"nflow-inspector\">\n    </aside>\n\n  </div>  \n  <footer>\n    <progress max=\"100\" value=\"0\" class=\"is-hidden\"></progress>\n    <span class=\"message\"></span>\n    \n    <nav>\n      <i class=\"fa fa-cog\"></i>\n    </nav>\n  </footer>\n</section>"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/debug/debug.tpl
// module id = 208
// module chunks = 0